/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Handle, Position } from '@xyflow/react'
import { MdOutlineListAlt } from 'react-icons/md'
import { Box } from '@chakra-ui/react'

function IncrementCountNode({ data, isConnectable }) {
  return (
    <>
      <Box className="custom-node-datahub node-error">
        <div className="node-header">
          <MdOutlineListAlt size={20} />
          <span>Log Error</span>
        </div>
        <div className="node-content">
          <div className="node-section">
            <div className="node-label">Counter</div>
            <div className="node-value">{data.logCounter}</div>
          </div>
          <div className="node-section">
            <div className="node-label">Message</div>
            <div className="node-value">{data.message}</div>
          </div>
        </div>
      </Box>
      <Handle type="target" position={Position.Top} />
      <Handle type="source" position={Position.Right} />
    </>
  )
}

export default IncrementCountNode
